export interface Image {
  title?: string;
  text: string;
  url?: string;
}
